<template>
  <v-app-bar app color="#EAAA54" clipped-left flat>
    <span
      v-if="!isMobileViewport || (!doesShowPropertySelect && !doesShowCog)"
      @click="onClickHome"
      style="cursor: pointer; color: white; white-space: nowrap"
    >
      <strong>Connected Space Share</strong>
    </span>
    <v-app-bar-nav-icon v-if="!isMobileViewport && doesShowDrawer" @click="onClickNavIcon" />
    <v-spacer v-if="!isMobileViewport" />
    <property-select-menu v-if="doesShowPropertySelect" />
    <user-account-menu v-if="doesShowCog" />
    <settings-menu v-if="doesShowCog" />
  </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import Store from '@/store';
import PropertySelectMenu from '@/components/header/PropertySelectMenu.vue';
import UserAccountMenu from '@/components/header/UserAccountMenu.vue';
import SettingsMenu from '@/components/header/SettingsMenu.vue';
import { switchExpand } from '@/libs/store/common';

@Component({
  components: {
    PropertySelectMenu,
    UserAccountMenu,
    SettingsMenu,
  },
})
export default class HeaderBar extends Vue {
  get doesShowDrawer() {
    return Store.getters.common.doesShowDrawer;
  }

  get doesShowPropertySelect() {
    return Store.getters.common.doesShowPropertySelect;
  }

  get doesShowCog() {
    return Store.getters.common.doesShowCog;
  }

  get isMobileViewport() {
    return ['xs', 'sm'].includes(this.$vuetify.breakpoint.name);
  }

  private onClickHome() {
    if (this.doesShowDrawer) {
      this.$router.push('/dashboard/home');
    }
  }

  private onClickNavIcon() {
    switchExpand();
  }
}
</script>
<style lang="scss"></style>
